import { z } from 'zod';
import { apiGet, apiPost, demoMode } from './api';
import { demoOwnerBookings } from './demo';

const NOTES_KEY = 'mnc-demo-client-notes';
export const ClientRecordSchema = z.object({
  phone: z.string(), name: z.string(), visits: z.coerce.number(), completed: z.coerce.number(),
  cancelled: z.coerce.number(), revenue: z.coerce.number(), first_seen_at: z.string(),
  last_visit_at: z.string(), note: z.string()
});
export type ClientRecord = z.infer<typeof ClientRecordSchema>;

function notes(): Record<string, string> {
  try { return JSON.parse(localStorage.getItem(NOTES_KEY) ?? '{}') as Record<string, string>; } catch { return {}; }
}

export async function fetchClients(): Promise<ClientRecord[]> {
  if (!demoMode) return z.array(ClientRecordSchema).parse(await apiGet('/owner/clients'));
  const grouped = new Map<string, ClientRecord>();
  for (const booking of demoOwnerBookings()) {
    const row = grouped.get(booking.client_phone) ?? {
      phone: booking.client_phone, name: booking.client_name, visits: 0, completed: 0,
      cancelled: 0, revenue: 0, first_seen_at: booking.starts_at, last_visit_at: booking.starts_at,
      note: notes()[booking.client_phone] ?? ''
    };
    row.visits += 1;
    if (booking.status === 'done') { row.completed += 1; row.revenue += booking.price; }
    if (booking.status === 'cancelled') row.cancelled += 1;
    if (booking.starts_at > row.last_visit_at) row.last_visit_at = booking.starts_at;
    grouped.set(row.phone, row);
  }
  return [...grouped.values()].sort((a, b) => b.last_visit_at.localeCompare(a.last_visit_at));
}

export async function saveClientNote(phone: string, note: string): Promise<void> {
  if (!demoMode) { await apiPost('/owner/clients', { phone, note }); return; }
  localStorage.setItem(NOTES_KEY, JSON.stringify({ ...notes(), [phone]: note }));
}

